import PropTypes from 'prop-types';

const LoadMoreButton = ({
  onLoadMore,
  loading,
  hasMore,
  remainingCount,
  className = 'btn btn-secondary btn-sm',
  loadingText = 'Loading...',
  buttonText = 'Load More',
}) => {
  if (!hasMore) return null;

  return (
    <div className="flex justify-center py-4 border-t">
      <button className={className} onClick={onLoadMore} disabled={loading}>
        {loading ? loadingText : remainingCount ? `${buttonText} (${remainingCount} remaining)` : buttonText}
      </button>
    </div>
  );
};

LoadMoreButton.propTypes = {
  onLoadMore: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  hasMore: PropTypes.bool,
  remainingCount: PropTypes.number,
  className: PropTypes.string,
  loadingText: PropTypes.string,
  buttonText: PropTypes.string,
};

export default LoadMoreButton;
